/**
 * Heavy dashboard screens that drive the global loader themselves.
 * For those we do not auto-hide the loader on every HTTP completion.
 */
const DASHBOARD_ROUTES_WITH_CUSTOM_LOADER = new Set<string>([
  '/dashboard/users',
  '/dashboard/document-type',
  '/dashboard/test-upload',
  '/dashboard/document-upload',
  '/dashboard/account-details',
  '/dashboard/configuration',
  '/dashboard/dashboard-charts',
  '/dashboard/audit-logs',
  '/dashboard/user-activity-logs',
]);

/** True when this route should get the default “hide loader after HTTP” behavior. */
export function shouldHideGlobalLoaderAfterHttp(routerUrl: string): boolean {
  return !DASHBOARD_ROUTES_WITH_CUSTOM_LOADER.has(routerUrl);
}
